/**
 * @file ResearchSectionButton.js
 * @module src/js/components/ResearchSectionButton
 * @description
 * **Component for research section action buttons (Edit, Save, Delete, Cancel).**
 * - Renders buttons to edit, save, delete, or cancel changes to research sections.
 * - Handles button states based on editing mode and updating status.
 * - Displays messages using the modal system.
 *
 * @version
 * <p>
 *  2025-12-02: First version with documentation. (Zong-Han Wu, zhwu@eda.ee.ntu.edu.tw)<br/>
 *  2025-12-02: Migrate to useUpdateProfile hook and refactor. (Zong-Han Wu, zhwu@eda.ee.ntu.edu.tw)<br/>
 * </p>
 */
import { useUser } from '../contexts/UserProvider';

export default function ResearchSectionButton({
    index,
    oneShowInput,
    setTitleRefToScrollIntoView,
    oneSectionData,
    updatedItem,
    oneUpdatedImgFile,
    updating,
    updateProfile,
    handleClickCancelEdit,
    withImage = true,
}) {
    const { uid } = useUser();

    const contentNotChanged = JSON.stringify(oneSectionData) === JSON.stringify(updatedItem);
    const imageNotUploaded = oneUpdatedImgFile == null;
    const isGuest = uid === 'Guest';

    return (
        <ul className="actions special">
            <li>
                {/* Save button */}
                {!isGuest && oneShowInput && (
                    <button
                        onClick={async () => {
                            await updateProfile({
                                request: '/api/research',
                                updatedProfileData: updatedItem,
                                updatedImgFile: oneUpdatedImgFile,
                                from: '/',
                                scrollTo: 'research',
                            });
                            setTitleRefToScrollIntoView(index);
                        }}
                        style={{ marginTop: '15px' }}
                        disabled={
                            (contentNotChanged &&
                            (!withImage || imageNotUploaded)) ||
                            updatedItem.title === '' ||
                            updatedItem.text === '' ||
                            updating
                        }
                        // Check oneUpdatedImgFile === null instead of comparing names
                        // because the updated image name may be the same as the original one
                    >
                        Save
                    </button>
                )}

                {/* Edit / Cancel button */}
                {!isGuest && (
                    <button
                        onClick={() => handleClickCancelEdit(index, withImage)}
                        style={{ marginTop: '15px', marginLeft: '15px', marginRight: '15px' }}
                        disabled={updating}
                    >
                        {oneShowInput ? 'Cancel' : 'Edit'}
                    </button>
                )}
                {!isGuest && !oneShowInput && (
                    <button
                        onClick={() => {
                            updateProfile({
                                request: `/api/research/${oneSectionData.researchID}`,
                                deleteSection: true,
                                from: '/',
                                scrollTo: 'research',
                            });
                        }}
                        style={{
                            marginTop: '15px',
                            color: 'lightcoral',
                            outline: '2px solid lightcoral',
                            outlineOffset: '-2px',
                        }}
                        disabled={updating}
                    >
                        Delete
                    </button>
                )}
            </li>
        </ul>
    );
}